export default __webpack_public_path__ + "static/media/project-status-money-returned.f1174317.svg";